"use strict";

exports.__esModule = true;
exports.default = void 0;

var componentPlugins = require("./components");

var directivePlugins = require("./directives");

var _plugins = require("./utils/plugins");

var _config = require("./utils/config");

var BootstrapVue = {
  install: function install(Vue) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Configure BootstrapVue
    (0, _config.setConfig)(config); // Register component plugins

    (0, _plugins.registerPlugins)(Vue, componentPlugins); // Register directive plugins

    (0, _plugins.registerPlugins)(Vue, directivePlugins);
  },
  setConfig: function setConfig()
  /* istanbul ignore next */
  {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _config.setConfig)(config);
  }
}; // Auto installation only occurs if window.Vue exists

(0, _plugins.vueUse)(BootstrapVue);
var _default = BootstrapVue;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/index.js
// module id = 309
// module chunks = 0